<!-- LOGIN PAGE  
  - Takes Email and (Password or OTP) to Login
  - Calls saveUser() function on clicking Login Button which actually send request to login the user
  - Calls sendOtp() function to send otp to email mentioned if we want to login using otp
  - onChange() function is called whenever we input email or password or otp to update with new Values
  - Commented by Sarthak on Feb 12, 2024
 -->
 <div class="landing_banner_outer" *ngIf="CGkey" >
    <div class="landing_banner" >
      <div>
        <img style="height: 100px;width: 150px;" src="assets/Smatar2.png">
      </div>
      <div style="right: 0;position: absolute;top: 0;">
        <img style="height: 100px;width: 115px;" src="assets/CG-logo1.png">
      </div>
      <div style="right: 0;position: absolute;color: #ffffff;bottom: 85px;padding-right: 16px;">
        <img style="height: 40px;width: 40px;" src="assets/twitter.png">
      </div>
  
      <div style="right: 0;position: absolute;bottom: 30px;color: #ffffff;padding-right: 16px;">
        <img style=" height: 40px;width: 40px;" src="assets/linkedin.png"> 
      </div>
  
      <div class="banner_cover">
        <div class="caption_text">
          <div class="container login_container_cg" id="component1">
            <form [formGroup]="userForm" (ngSubmit)="saveUser()">
              <div class="row" style="    width: 700px;">
                <div class="col-md-4 mx-auto custom_mx">
                  <div class="card-group login_outer">
                    <div class="card p-4" style="    background: #ededed;">
                      <div class="card-body p_10">
                       
                        <p class="text-muted p_t_10" style="color: #0b54a0 !important;text-align: right;">Sign In to your account</p>
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span style="background: #ededed;border: unset;" class="input-group-text no_radius"><i class="material-icons">email</i>
                            </span>
                          </div>
                          <input type="text" class="form-control" placeholder="Email" autocomplete="username"
                            formControlName="email" id="email">
                          
                              <!-- <control-messages  style="height: 10px;
                              padding-left: 50px;
                          " class="err-msg" [control]="userForm.controls.email"></control-messages> -->
                           
                        </div>
                        <div class="full_pass_field">
                          <div class="input-group mb-4" *ngIf="passwordDiv">
                            <div class="input-group-prepend">
                              <span style=" background: #ededed;border: unset !important;" class="input-group-text no_radius"><i
                                  class="material-icons">lock</i></span>
                            </div>
                            <input type="password" class="form-control" placeholder="Password"
                              autocomplete="current-password" formControlName="password" id="password" readonly onfocus="if (this.hasAttribute('readonly')) { this.removeAttribute('readonly');this.blur();this.focus(); }">
                            <!-- <control-messages style="height: 10px;
                            padding-left: 50px;
                        " class="err-msg" [control]="userForm.controls.password"></control-messages> -->
                          </div>
                          <div class="input-group mb-4" *ngIf="otpDiv">
                            <div class="input-group-prepend">
                              <span style="background: #ededed;border: unset;" class="input-group-text no_radius"><i class="material-icons">lock</i></span>
                            </div>
                            <input type="password" class="form-control" placeholder="OTP" autocomplete="current-password"
                              formControlName="otp" id="otp" readonly onfocus="if (this.hasAttribute('readonly')) { this.removeAttribute('readonly');this.blur();this.focus();  }">
                            <!-- <control-messages  style="height: 10px;
                            padding-left: 50px; " class="err-msg" [control]="userForm.controls.otp"></control-messages> -->
                          </div>
  
                          <div class="togg_switch_box">
                            <label class="switch m_l_10">
                              <input type="checkbox" id="togBtn" (change)="onChange($event)">
                              <div class="slider round">
                                <span class="on">OTP</span>
                                <span class="off">Password</span>
                              </div>
                            </label>
                            <div class="send_otp_link" (click)="sendOtp()" style="  color: #0b54a0 !important;"><img
                                style="height: 13px;width: 13px;margin-bottom:3px;" *ngIf="loaderOtp" src="assets/img/loader.gif" />Send OTP</div>
                          </div>
                        </div>
  
  
                        <div class="row actions_row" style="">
                          <div class="col-6">
                           
                          </div>
                          <div class="col-6 text-right">
                          
                      <button class="btn primary_btn" type="submit" [disabled]="!userForm.valid">Login <img style="height: 15px;width: 15px;" *ngIf="loaderImg" src="assets/img/loader.gif"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
  
  
  
        </div>
      </div>
    </div>
  </div>
  
  <div class="container login_container" id="component1" >
    <form [formGroup]="userForm" (ngSubmit)="saveUser()">
      <div class="row">
        <div class="col-md-4 mx-auto custom_mx">
          <div class="card-group login_outer">
            <div class="card p-4">
              <div class="card-body p_10">
                <h2>Login</h2>
                <p class="text-muted p_t_10">Sign In to your account</p>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text no_radius"><i class="material-icons">email</i>
                    </span>
                  </div>
                  <input type="text" class="form-control" (ngModelChange)="getInputValue($event)" placeholder="Email" autocomplete="username"
                    formControlName="email" id="email">
                  <!-- <control-messages class="err-msg" [control]="userForm.controls.email"></control-messages> -->
                </div>
                <div class="full_pass_field">
                  <div class="input-group mb-4" *ngIf="passwordDiv">
                    <div class="input-group-prepend">
                      <span class="input-group-text no_radius"><i class="material-icons">lock</i></span>
                    </div>
                    <input type="password" class="form-control" placeholder="Password" autocomplete="current-password"
                      formControlName="password" id="password">
                    <!-- <control-messages class="err-msg" [control]="userForm.controls.password"></control-messages> -->
                  </div>
  
  
                  <div class="input-group mb-4" *ngIf="otpDiv">
                    <div class="input-group-prepend">
                      <span class="input-group-text no_radius"><i class="material-icons">lock</i></span>
                    </div>
                    <input type="password" class="form-control" placeholder="OTP" autocomplete="current-password"
                      formControlName="otp" id="otp">
                    <!-- <control-messages class="err-msg" [control]="userForm.controls.otp"></control-messages> -->
                  </div>
  
                  <div class="togg_switch_box">
                    <label class="switch m_l_10">
                      <input type="checkbox" id="togBtn" (change)="onChange($event)">
                      <div class="slider round">
                        <span class="on">OTP</span>
                        <span class="off">Password</span>
                      </div>
                    </label>
                    <div class="send_otp_link" (click)="sendOtp()"><img style="height: 13px;
                      width: 13px;margin-bottom:3px;" *ngIf="loaderOtp" src="assets/img/loader.gif" />Send OTP</div>
                  </div>
                </div>
  
  
                <div class="row actions_row" style="align-items: center;">
                  <div class="col-6">
                    <button class="btn primary_btn" type="submit"
                      [disabled]="!userForm.valid">Login <img style="height: 15px;
                      width: 15px;" *ngIf="loaderImg" src="assets/img/loader.gif"></button>
                  </div>
                  <div class="col-6 text-right">
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  